import { render, staticRenderFns } from "./DownloadInfo.vue?vue&type=template&id=1a3faa94&scoped=true&"
import script from "./DownloadInfo.vue?vue&type=script&lang=js&"
export * from "./DownloadInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3faa94",
  null
  
)

export default component.exports